/**
 * Created by yangxuanbin on 07/02/2018
 **/
export function userLogin(data){
  return {
    type:"LOGIN",
    data:data
  }
}

export function userLoginOut(){
    return {
        type:"LOGINOUT",
        data:{}
    }
}


// WEBPACK FOOTER //
// ./src/reduxModule/actions/user.js